module.exports = __webpack_public_path__ + "img/gameInterest.450f8126.svg";